// extracted by mini-css-extract-plugin
export default {"container":"AccordionTable_container__VT+rL","title":"AccordionTable_title__3uxHm"};